/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// @flow

import React, { Component } from 'react';

import type { Status } from 'types/Status';
import EmptyState from 'components/competitionsInternationales/CompetitionsinternationalesSingleMatchEmptyState';
import type { CompetitionInternationale } from 'types/competitionsInternationales';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import { STATUS_SUCCESS } from 'constants/statusConstants';
import { withHelmet } from 'infrastructure/seo/Helmet';

import './CompetitionsInternationalesMatchsResults.css';

import './competitionLinearCourse.css';

export type StateProps = {
  data: CompetitionInternationale,
  status: Status
};

type Props = StateProps;

type State = {
  typeClassment: string
};

class CompetitionsInternationalesClassement extends Component<Props, State> {
  state = {
    typeClassment: 'poules'
  };

  render() {
    const { data } = this.props;
    const { typeClassment } = this.state;

    if (!data.content_classement_competition) {
      return null;
    }

    const titre = `Classement des Équipes : ${data.title.raw}`;

    return (
      <>
        <section className="classement-competition">
          <div className="dropdown-container">
            <h2>{titre}</h2>
          </div>

          {data.content_classement_competition &&
            !!data.content_classement_competition.navigation &&
            !!data.content_classement_competition.navigation.length && (
              <nav className="single-match__nav">
                <ul>
                  {data.content_classement_competition.navigation.map(item => (
                    <li
                      key={item.typeClassement}
                      className={typeClassment === item.typeClassement ? 'active' : ''}
                      onClick={() => this.setState({ typeClassment: item.typeClassement })}
                    >
                      <span>{item.label}</span>
                    </li>
                  ))}
                </ul>
              </nav>
            )}

          <div className="classement-competition__content">
            {typeClassment === 'poules' &&
              data.content_classement_competition.phase_de_poule &&
              data.content_classement_competition.phase_de_poule.data &&
              data.content_classement_competition.phase_de_poule.data.length > 0 &&
              data.content_classement_competition.phase_de_poule.data.map((bloc, index) => (
                <ContentBloc key={index} {...bloc} />
              ))}

            {typeClassment === 'poules' &&
              (!data.content_classement_competition.phase_de_poule ||
                !data.content_classement_competition.phase_de_poule.data ||
                !data.content_classement_competition.phase_de_poule.data.length === 0) && (
                <EmptyState
                  titleFirstPart="Phase"
                  titleSecondPart="Finale"
                  description="Le classement de la phase de poule n'est pas encore disponible."
                  backgroundImage="/img/empty-state-statistiques.png"
                />
              )}

            {typeClassment === 'finales' &&
              data.content_classement_competition.phase_finale &&
              data.content_classement_competition.phase_finale.data &&
              data.content_classement_competition.phase_finale.data.length > 0 &&
              data.content_classement_competition.phase_finale.data.map((bloc, index) => (
                <ContentBloc key={index} {...bloc} />
              ))}

            {typeClassment === 'finales' &&
              (!data.content_classement_competition.phase_finale ||
                !data.content_classement_competition.phase_finale.data ||
                data.content_classement_competition.phase_finale.data.length === 0) && (
                <EmptyState
                  titleFirstPart="Phase"
                  titleSecondPart="Finale"
                  description="Le tableau de la phase finale n'est pas encore disponible."
                  backgroundImage="/img/empty-state-statistiques.png"
                />
              )}
          </div>
        </section>

        <div className="mt-7">
          {!!data &&
            !!data.content_classement_competition &&
            !!data.content_classement_competition.bottom_page &&
            !!data.content_classement_competition.bottom_page.data &&
            !!data.content_classement_competition.bottom_page.data.length &&
            data.content_classement_competition.bottom_page.data.map((bloc, index) => (
              <ContentBloc key={index} {...bloc} />
            ))}
        </div>
      </>
    );
  }
}

export default withHelmet(CompetitionsInternationalesClassement)((Helmet, pageProps: Props) => {
  const { data, status } = pageProps;

  if (status !== STATUS_SUCCESS || !data) {
    null;
  }

  const meta_title = `Classement des Équipes - ${data.title.raw} - FFR`;

  return (
    <Helmet htmlAttributes={{ lang: 'fr' }}>
      {meta_title && <title>{meta_title}</title>}
      {meta_title && <meta property={'og:title'} content={meta_title} />}
    </Helmet>
  );
});
